import Box from '@mui/material/Box'
import LoginBackground from '@/assets/img/LoginBackground.jpg'

export const LogoContainer = () => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${LoginBackground})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '50%'
      }}
    />
  )
}
